import { createElement } from "react";
import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

import {
  ASSET_ASSIGNMENTS_UPDATE,
  ASSET_ASSIGNMENTS_VIEW,
} from "../../../../permissions";
import { requirePermission } from "../../../../presentation/routes/requirePermission";
import type { AssetAssignmentsRouteFactory } from "./assetAssignmentsRouteContext";
import { assetAssignmentsSearchSchema } from "./searchSchemas";

const AssetAssignmentsListScreen = lazyRouteComponent(
  () => import("../AssetAssignmentsListScreen"),
  "AssetAssignmentsListScreen",
);
const AssetAssignmentCreateScreen = lazyRouteComponent(
  () => import("../AssetAssignmentCreateScreen"),
  "AssetAssignmentCreateScreen",
);

export const createAssetAssignmentsRoutes: AssetAssignmentsRouteFactory = ({
  context,
  basePath,
  assetAssignments,
  branches,
  assets,
}) => [
  createRoute({
    getParentRoute: context.getParentRoute,
    path: basePath,
    validateSearch: assetAssignmentsSearchSchema,
    beforeLoad: requirePermission([ASSET_ASSIGNMENTS_VIEW]),
    component: () =>
      createElement(AssetAssignmentsListScreen, {
        repository: assetAssignments,
        basePath,
      }),
  }),
  createRoute({
    getParentRoute: context.getParentRoute,
    path: `${basePath}/create`,
    beforeLoad: requirePermission([ASSET_ASSIGNMENTS_UPDATE]),
    component: () =>
      createElement(AssetAssignmentCreateScreen, {
        repository: assetAssignments,
        branches,
        assets,
        basePath,
      }),
  }),
];
